<script context="module" lang="ts">
  import { browser } from '$app/environment';

  const threshold = 0.25;
  let observer: IntersectionObserver | undefined = undefined;
  if (browser && observer === undefined) {
    observer = new IntersectionObserver(
      entries => {
        for (const entry of entries) {
          entry.target.dispatchEvent(new CustomEvent('visible', { detail: entry.isIntersecting }));
        }
      },
      { threshold }
    );
  }
</script>

<script lang="ts">
  import { createEventDispatcher, onMount } from 'svelte';

  const dispatch = createEventDispatcher();

  export let id = '';
  export let instant = false;
  export let inView = false;
  export let el: HTMLElement | null = null;
  export let hideOutsideView = false;

  let className = '';
  export { className as class };

  let isVisible = false;

  let showDirectly = false;
  let scrollY: number;
  let isMounted = false;

  function changeVisibility(event) {
    dispatch('change', event.detail);
    inView = event.detail;
    // Don't hide elements if they are visible.
    if (!isVisible) {
      isVisible = event.detail;
    }
  }

  onMount(() => {
    // Only hide the element using opacity after the JS is loaded (so we don't have a blank page while JS is loading).
    isMounted = true;

    // If the page is first loaded scrolled down (for example after a refresh, or when going back)
    // then show all elements directly, not when they come into view.
    showDirectly = scrollY > 0;

    observer?.observe(el!);
    el!.addEventListener('visible', changeVisibility);

    return () => {
      observer?.unobserve(el!);
      el!.removeEventListener('visible', changeVisibility);
    };
  });
</script>

<svelte:window bind:scrollY />

<div bind:this={el} {id} class={className}>
  {#if isVisible || instant || showDirectly}
    <slot />
  {:else if !hideOutsideView}
    <div class:opacity-0={isMounted}>
      <slot />
    </div>
  {/if}
</div>
